import '../src/scss/App.scss';
import HeaderComponent from './components/HeaderComponent';
import HomePages from './pages/Home/HomePages';
import BasePages from './pages/Base/BasePages';
import {BrowserRouter, Route, RouterProvider, Routes, createBrowserRouter } from 'react-router-dom';
import RegistroPages from './pages/Registro/RegistroPages';
import TablaPages from './pages/Tabla/TablaPages';
import ConteoPages from './pages/Conteo/ConteoPages';
import ResultadoConteoPages from './pages/Resultados/ResultadoConteoPages';
import MesasPages from './pages/Mesas/MesasPages';
import CatalogosPages from './pages/Catalogos/CatalogosPages';
import UsuariosPages from './pages/Usuarios/UsuariosPages';
import AgendaPages from './pages/Agenda/AgendaPages';
import PerfilPages from './pages/Perfil/PerfilPages';
import AdministradoresPages from './pages/Administradores/AdministradoresPages';
import PrivateRoute from './routes/PrivateRoute';
import EstadoConexionComponent from './components/EstadoConexionComponent';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { ACCESO_SUPERADMIN, ROLES, RUTA_LOGIN_SUPERADMIN, cerrarSesion, obtenerRol, rutaLogin, sincronizarDatosSesion } from './utils/sesion';
import { obtenerSesionActual } from './Api/autenticacion';

const TODOS = [ROLES.ADMIN, ROLES.DIGITADOR];
const SOLO_ADMIN = [ROLES.ADMIN];
const SOLO_SUPERADMIN = [ROLES.SUPERADMIN];
// perfil: cualquier usuario con sesión
const CUALQUIER_ROL = [...TODOS, ROLES.SUPERADMIN];

function App() {
  const token = Cookies.get('token');
  // con sesión abierta, las rutas esperan a confirmar el rol con el backend
  // (si no, una sesión sin rol guardado sería redirigida antes de tiempo)
  const [sesionLista, setSesionLista] = useState(!token);

  useEffect(() => {
    if (!token) return;
    obtenerSesionActual()
      .then((datos) => sincronizarDatosSesion(datos))
      .catch((error) => {
        // token vencido/inválido, usuario desactivado o cuenta vencida: se cierra la sesión
        if (error.response?.status === 401) {
          const login = rutaLogin(obtenerRol());
          cerrarSesion();
          if (window.location.pathname !== login) window.location.href = login;
        }
      })
      .finally(() => setSesionLista(true));
  }, [token]);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <HomePages />,

    },
    {
      // login privado del superadmin
      path: RUTA_LOGIN_SUPERADMIN,
      element: <HomePages acceso={ACCESO_SUPERADMIN} />,
    },
    {
      path: "/base",
      element: <BasePages />,
    },
    {
      path: "/registro",
      element:  <PrivateRoute  canActivate={token} roles={TODOS} component={<RegistroPages/>} />,
    },
    {
      path: "/consulta",
      element:  <PrivateRoute  canActivate={token} roles={TODOS} component={<TablaPages />} />
    },
    {
      path: "/conteo",
      element:<PrivateRoute  canActivate={token} roles={TODOS} component={<ConteoPages />} />
    },
    {
      path: "/resultado",
      element: <PrivateRoute  canActivate={token} roles={TODOS} component={<ResultadoConteoPages />} />
    },
    {
      path: "/mesas",
      element: <PrivateRoute  canActivate={token} roles={TODOS} component={<MesasPages />} />
    },
    {
      path: "/agenda",
      element: <PrivateRoute  canActivate={token} roles={TODOS} component={<AgendaPages />} />
    },
    {
      path: "/perfil",
      element: <PrivateRoute  canActivate={token} roles={CUALQUIER_ROL} component={<PerfilPages />} />
    },
    {
      path: "/administradores",
      element: <PrivateRoute  canActivate={token} roles={SOLO_SUPERADMIN} component={<AdministradoresPages />} />
    },
    {
      path: "/catalogos",
      element: <PrivateRoute  canActivate={token} roles={SOLO_ADMIN} component={<CatalogosPages />} />
    },
    {
      path: "/usuarios",
      element: <PrivateRoute  canActivate={token} roles={SOLO_ADMIN} component={<UsuariosPages />} />
    }
      
  ])
  return (
    <div className='app'>
    
    {sesionLista && (
      <>
        <div className='header-fijo '>
            <HeaderComponent />
        </div>
        <div className='body'>
           <RouterProvider router={router} />
        </div>
        {/* modo sin conexión: indicador y envío de lo guardado en el equipo */}
        {token && <EstadoConexionComponent />}
      </>
    )}
    
    </div>
  );
}

export default App;
